export default __webpack_public_path__ + "locales/ru/JavascriptSdk.json?hash=ba7a111711ed45760279cd671ae847a5";